import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCuttingPlanStore } from '../../stores/cuttingPlanStore';

const WasteTable = () => {
    const { t } = useTranslation();

    const allPatterns = useCuttingPlanStore(state => state.allPatterns);
    const showedPatterns = allPatterns.filter(pattern => pattern.show);
    const wastedPatterns = showedPatterns.filter(pattern => pattern.waste != 0 && !pattern.preCut);
    const wasteDict = {};
    wastedPatterns.forEach(pattern => {
        if (pattern.waste in wasteDict) {
            wasteDict[`${pattern.diameter}-${pattern.waste}`].push(pattern);
        } else {
            wasteDict[`${pattern.diameter}-${pattern.waste}`] = [pattern];
        }
    });

    const sortPairs = (a, b) => {
        if (a[0] === b[0]) {
            return a[1] - b[1];
        }
        return a[0] - b[0];
    }

    return (
        <div className='table-responsive'>
            {wastedPatterns.length === 0 ? (
                <div className="alert alert-secondary text-center" role="alert">
                    {t("Fire bulunmamaktadır.")}
                </div>
            ) :
                <table className="table table-sm border text-center align-middle">
                    <thead>
                        <tr>
                            <th scope="col" style={{ width: "20%" }}>{t("Uzunluk")} (cm)</th>
                            <th scope="col" style={{ width: "20%" }}>{t("Adet")}</th>
                            <th scope="col" style={{ width: "20%" }}>{t("Çap")}</th>
                            <th scope="col" style={{ width: "40%", textAlign: "start" }}>{t("Kesim No.")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(wasteDict)
                            .sort((a, b) => sortPairs(b.split("-"), a.split("-")))
                            .map((waste, i) => (
                                <tr key={i}>
                                    <td>{waste.split("-")[1]}</td>
                                    <td>
                                        {wasteDict[waste].reduce((acc, pattern) => acc + pattern.nLogs, 0)}
                                    </td>
                                    <td>
                                        {wasteDict[waste][0].diameter}
                                    </td>
                                    <td style={{ textAlign: "start" }}>
                                        {wasteDict[waste].map((pattern, i) => `${pattern.patternNo}`).join(", ")}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            }
        </div>
    );
}

export default WasteTable;